import React from "react";
import "./Header.scss";

function Header({ categoryInfo, children }) {
  // Avoid loading the fallback image too early, before the categoryInfo prop
  // has had a chance to load data from server response.
  const categoryInfoLoaded = Object.keys(categoryInfo).length > 0;

  const bgImg = categoryInfo.featured_image
    ? categoryInfo.featured_image
    : "/themes/custom/emoryaae/images/default-giving-background.jpg";

  const inlineStyle = {
    backgroundImage: "url(" + bgImg + ")",
  };

  return (
    <div
      className="fund-category__header coh-style-container-theme---dark-1"
      style={categoryInfoLoaded ? inlineStyle : null}
    >
      <div className="fund-category__header-inner coh-container coh-container-boxed">
        {categoryInfo.logo ? (
          <img
            className="fund-category__header-logo"
            src={categoryInfo.logo}
            height="175"
          />
        ) : null}
        <h1
          className={`fund-category__header-title ${
            categoryInfo.logo ? "visually-hidden" : ""
          }`}
        >
          {categoryInfo.name}
        </h1>
        {children}
      </div>
    </div>
  );
}

export default Header;
